import React from "react"
export function PolandFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Poland"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__poland" fillRule="nonzero">
          <path
            id="prefix__Path"
            stroke="#CCC"
            strokeWidth={0.5}
            fill="#FFF"
            d="M23.75 9.75V.25H.25v9.5z"
          />
          <path id="prefix__Path" fill="#FF4B55" d="M0 8h24v8H0z" />
        </g>
      </g>
    </svg>
  )
}
